<template>
  <div class="policyInformation">
    <el-row>
      <!-- 面包屑 -->
      <el-col :span="24"
        ><Breadcrumbs :arr="['碳汇管理平台', '零碳课堂明细']"
      /></el-col>
      <!-- 查询表单 -->
      <el-col class="search" :span="24">
        <el-form :inline="true" :model="search" class="demo-form-inline">
          <el-form-item id="time" label="日期">
            <el-date-picker
            v-model="search.startDate"
            type="datetime"
            size="small"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptionsYear"
            style="width: 200px"
            placeholder="开始日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-date-picker
            v-model="search.endDate"
            type="datetime"
            size="small"
            format="yyyy-MM-dd"
            :picker-options="pickerOptionsYear1"
            value-format="yyyy-MM-dd"
            style="width: 200px"
            placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="btn">
            <!-- class="theme-btn" -->
            <el-button size="small" type="primary" @click="getList" round
              >查询</el-button
            >
            <el-button
              size="small"
              style="margin: 0 0 0 50px"
              @click="reset"
              round
              type="info"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 表格数据 -->
      <el-col class="main_table" :span="24">
        <div class="table_btn">
          <!-- class="theme-btn" -->
          <el-button size="small" type="primary" @click="isAddData" round
            >新增</el-button
          >
        </div>
        <Tables
          class="table"
          :columns="columns"
          :loading="loading"
          :tableData="tableData"
        >
          <template #updateTime="scope">
             <div>
                {{scope.row.updateTime?scope.row.updateTime.split('T')[0]:''}}
              </div>
          </template>
          <template #actions="scope">
            <div class="flex" v-if="scope.row.id">
              <!-- <span class="theme-color">修改</span>
                            <span class="theme-color">删除</span>
                            <span class="theme-color">详情</span> -->
              <el-button type="text" @click="isEdit(scope.row)"
                >修改</el-button
              >
              <el-button type="text" @click="isDelete(scope.row.id)"
                >删除</el-button
              >
              <el-button type="text" @click="isView(scope.row)"
                >详情</el-button
              >
            </div>
          </template>
        </Tables>
        <Paginations :pageData="pageData" :sizeChange="sizeChange" :currentChange="currentChange" />
      </el-col>
    </el-row>
    <modaDialogl
      :dialog="dialog"
      :formData="formData"
      :handleClose="handleClose"
      :isView="isShowView"
    />
  </div>
</template>
<script>
import {
  getZeroCarbonClassroomDetailPageList,
  removeZeroDetail,
} from "@/api/api";
import Breadcrumbs from "@/components/breadcrumbs/breadcrumbs.vue";
import Tables from "@/components/tables/tables.vue";
import modaDialogl from "./components/modaDialogl.vue";
import Paginations from "@/components/paginations/paginations.vue";
import { columns } from "./js/columns";
export default {
  name: "policyInformation",
  data() {
    return {
      search: {
        date: "",
      },
      // 表格展示数据
      tableData: [],
      // 表格显示标题
      columns: [],
      loading: false,
      // 弹出框设置
      dialog: {
        size: 720,
        visible: false,
        title: "新增",
      },
      // 分页
      pageData: {
        size: 10,
        page: 1,
        total: 0,
      },
      // 是否显示操作按钮
      isShowView: true,
      // 用户信息
      userInfo: {},
      // 表单信息
      formData: {},
       pickerOptionsYear: {
        disabledDate: (time) => {
          const start = Date.parse(this.search.startDate);
          const end = Date.parse(this.search.endDate);
          if (this.search.endDate) {
            return time.getTime() > Date.now() || time.getTime() > end;
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      pickerOptionsYear1: {
          disabledDate: (time) => {
            const start = Date.parse(this.search.startDate);
            const end = Date.parse(this.search.endDate);
            if (this.search.startDate) {
              return (
                time.getTime() < start - 8.64e7
              );
            } else {
              // return time.getTime() > Date.now();
            }
          },
      },
    };
  },
  methods: {
    // 页面初始化
    init() {
      
      if(localStorage.getItem('userInfo'))
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      this.columns = columns;
      this.getList();
      
    },
    // 获取数据列表
    getList() {
      let page = {
        current: this.pageData.page,
        size: this.pageData.size,
      };
      this.loading = true
      getZeroCarbonClassroomDetailPageList(this.search, page).then((res) => {
        if (res.data.code == "200") {
          this.tableData = res.data.data.records;
          this.pageData.total = res.data.data.total;
          this.tableData.forEach((item) => {
            item.accessory = item.accessory ? JSON.parse(item.accessory) : [];
          });
        }
        this.loading = false
      });
    },
    // 点击重置
    reset() {
      this.search = {
        date: "",
      };
      this.getList();
    },
    // 关闭弹出框
    handleClose() {
      this.dialog.visible = false;
    },
    // 新增
    isAddData() {
      this.formData = {
        date:"", // 日期
        peopleNumber: "", // 人数
        cost: "", // 费用
        timeNumber: "", // 次数
        userId: this.userInfo.id,
        userName:this.userInfo.name,
      };
      this.dialog.visible = true;
      this.isShowView = true;
      this.dialog.title = "新增";
    },
    // 修改
    isEdit(row) {
      delete row.createTime
      delete row.updateTime
      row.userId = this.userInfo.id,
      row.userName = this.userInfo.name,
      this.formData = JSON.parse(JSON.stringify(row));
      this.dialog.visible = true;
      this.dialog.title = "修改";
      this.isShowView = true;
    },
    // 详情
    isView(row) {
      this.formData = JSON.parse(JSON.stringify(row));
      this.dialog.visible = true;
      this.dialog.title = "详情";
      this.isShowView = false;
    },
    // 删除
    isDelete(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          removeZeroDetail(id).then((res) => {
            if (res.data.code == 200) {
              if (this.tableData.length == 1) {
                let page = this.pageData.page - 1;
                page = page <= 0 ? 0 : page;
                this.pageData.page = page;
              }
              this.getList();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 通过类型返回文字
    changeType(type){
        if(type==0) return '政策信息发布'
        else if(type==1) return '工作推进成果'
        else return ''
    },
    // 切换条数
    sizeChange(val){
        this.pageData.size = val
        this.getList()
    },
    // 切换页数
    currentChange(val){
        this.pageData.page = val
        this.getList()
    },
    setUrl(arr){
      arr = JSON.parse(arr)
      if(arr.length)
        return arr[0].url
      else return ''
    },
  },
  mounted() {
    this.init();
  },
  components: {
    Breadcrumbs,
    Tables,
    modaDialogl,
    Paginations,
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.operation{
  color: #409EFF;
}
</style>